export const ticketsDataMapper = (data) => {
    const result = {
        type: "",
        list: [],
    };
    if (data && data.list) {
        const tickets = data.list.map((item) => {
            return {
                comments: item.comments,
                createdDate: item.createdDate,
                description: item.description,
                ticketId: item.ticketId,
                closedDate: item.closedDate,
                status: item.status
            };
        });
        result.type = data === null || data === void 0 ? void 0 : data.type;
        result.list = tickets;
    }
    return result;
};
